export default "__VITE_ASSET__b59090b0__"